// Generated by genversion.
export const version = '2.1.23';
